import axios, { AxiosResponse } from 'axios';
import { 
  DogProfile, 
  ActivityConfig, 
  Timer, 
  ActivityAction
} from '../types';

const BACKEND_URL = import.meta.env.VITE_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

class ApiService {
  // Dog Profile APIs
  async getDogProfile(): Promise<DogProfile | null> {
    try {
      const response: AxiosResponse<DogProfile> = await axios.get(`${API}/dog-profile`);
      return response.data;
    } catch (error) {
      console.error('Error fetching dog profile:', error);
      return null;
    }
  }

  async createDogProfile(dogData: Partial<DogProfile>): Promise<DogProfile> {
    const response: AxiosResponse<DogProfile> = await axios.post(`${API}/dog-profile`, dogData);
    return response.data;
  }

  async updateDogProfile(dogData: DogProfile): Promise<void> {
    await axios.put(`${API}/dog-profile`, dogData);
  }

  // Activity Configuration APIs
  async getActivityConfigs(): Promise<ActivityConfig[]> {
    const response: AxiosResponse<ActivityConfig[]> = await axios.get(`${API}/activity-config`);
    return response.data;
  }

  async createActivityConfig(activityData: Omit<ActivityConfig, 'id'>): Promise<ActivityConfig> {
    const response: AxiosResponse<ActivityConfig> = await axios.post(`${API}/activity-config`, activityData);
    return response.data;
  }

  async updateActivityConfig(activityId: string, activityData: Partial<ActivityConfig>): Promise<void> {
    await axios.put(`${API}/activity-config/${activityId}`, activityData);
  }

  async deleteActivityConfig(activityId: string): Promise<void> {
    await axios.delete(`${API}/activity-config/${activityId}`);
  }

  // Timer APIs
  async getTimerStatus(): Promise<Timer[]> {
    const response: AxiosResponse<Timer[]> = await axios.get(`${API}/timer-status`);
    return response.data;
  }

  async completeTimer(activityConfigId: string, activity: ActivityAction): Promise<void> {
    await axios.post(`${API}/complete-timer/${activityConfigId}`, activity);
  }

  // Initialization APIs
  async initializeDefaultActivities(): Promise<void> {
    await axios.post(`${API}/init-default-activities`);
  }
}

export const apiService = new ApiService();
export default apiService;